import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { ROUTER_OUTLET_KEY } from './constants';
import { closeOverlayOutlet, go, openOverlayOutlet } from './router.actions';

/**
 * OverlayOutlet effects
 */
@Injectable()
export class OverlayOutletEffects {
  public openOverlayOutlet$ = createEffect(() =>
    this.actions$.pipe(
      ofType(openOverlayOutlet),
      map(({ overlayPath }) =>
        go({
          commands: [
            {
              outlets: {
                overlay: overlayPath,
              },
            },
          ],
          extras: {
            queryParamsHandling: 'preserve',
            state: { [ROUTER_OUTLET_KEY]: true },
          },
        }),
      ),
    ),
  );

  public closeOverlayOutlet$ = createEffect(() =>
    this.actions$.pipe(
      ofType(closeOverlayOutlet),
      map(() =>
        go({
          commands: [
            {
              outlets: { overlay: null },
            },
          ],
          extras: {
            queryParamsHandling: 'preserve',
            state: { [ROUTER_OUTLET_KEY]: true },
          },
        }),
      ),
    ),
  );

  /** Dependencies */
  constructor(private actions$: Actions) {}
}
